export default __webpack_public_path__ + "static/media/2402.29728cb5.png";